import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StihlDistributorBillingDTO, StihlDistributorDTO, StihlDistributorDataDTO, StihlDistributorMaterialSendingDTO } from '../models/stihl-distributor-dto';
import { DataTablesResponse } from '../models/datatables';


@Injectable({
  providedIn: 'root'
})

export class DistributorService {

  private pathAPI = environment.urlAPI;
  private controller = "StihlDistributor/";

  constructor(private http: HttpClient) { }

  public GetDistributorMaterialSendingAddressList(id: string): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetDistributorMaterialSendingAddressList/' + id);
  }

  public get(id: string): Observable<StihlDistributorDTO> {
    return this.http.get<StihlDistributorDTO>(this.pathAPI + this.controller + id);
  }

  public getByUser(): Observable<StihlDistributorDTO> {
    return this.http.get<StihlDistributorDTO>(this.pathAPI + this.controller + "GetByUser");
  }

  public insertDistributorLogo(data: FormData): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + "InsertDistributorLogo", data);
  }

  public deleteLogo(idLogo: string): Observable<any> {
    return this.http.delete(this.pathAPI + this.controller + 'DeleteLogo/' + idLogo);
  }

  //#region DISTRIBUTOR DATA

  public getDistributorData(id: string): Observable<StihlDistributorDataDTO> {
    return this.http.get<StihlDistributorDataDTO>(this.pathAPI + this.controller + 'GetDistributorData/' + id);
  }

  public postDistributorData(data: any): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'PostDistributorData', data);
  }

  public putDistributorData(id: string, data: any): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'PutDistributorData/' + id, data);
  }

  //#endregion

  //#region DISTRIBUTOR BLLING

  public getDistributorBilling(id: string): Observable<StihlDistributorBillingDTO> {
    return this.http.get<StihlDistributorBillingDTO>(this.pathAPI + this.controller + 'GetDistributorBilling/' + id);
  }

  public postDistributorBilling(Billing: any): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'PostDistributorBilling', Billing);
  }

  public putDistributorBilling(id: string, Billing: any): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'PutDistributorBilling/' + id, Billing);
  }

  public deleteDistributorBilling(id: string): Observable<any> {
    return this.http.delete<any>(this.pathAPI + this.controller + 'DeleteDistributorBilling/' + id);
  }

  public getDistributorBillingDataTable(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTableBilling/', data);
  }

  //#endregion

  //#region DISTRIBUTOR MATERIAL SENDING

  public getDistributorMaterialSending(id: string): Observable<StihlDistributorMaterialSendingDTO> {
    return this.http.get<StihlDistributorMaterialSendingDTO>(this.pathAPI + 'StihlDistributor/GetDistributorMaterialSending/' + id);
  }

  public postMaterialSending(data: any): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'PostDistributorMaterialSending', data);
  }

  public putDistributorMaterialSending(id: string, data: any): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'PutDistributorMaterialSending/' + id, data);
  }

  public deleteDistributorMaterialSending(id: string): Observable<any> {
    return this.http.delete<any>(this.pathAPI + this.controller + 'DeleteDistributorMaterialSending/' + id);
  }

  public getDistributoMaterialSendingDataTable(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTableMaterialSending/', data);
  }


  //#endregion

  public apiDistributorFullLoad(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'ApiDistributorFullLoad');
  }

  public getDistributorDataTable(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/', data);
  }

  GetListadoDistris(): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetDistributorExcel';

    return this.http.post<Blob>(endpoint, null, requestOptions);
  }


}
